export const attendanceStatusOptions = [
    { value: 'all', label: 'All attendance statuses' },
    { value: 'attending', label: 'Attending' },
    { value: 'notAttending', label: 'Not attending' },
    { value: 'notImported', label: 'Not imported' },
];

export const getAttendanceStatus = registrant => registrant?.willAttend === true ? 'attending'
    : registrant?.willAttend === false ? 'notAttending' : 'notImported';

export const matchesAttendanceStatus = (registrant, status = 'all') => status === 'all'
    || getAttendanceStatus(registrant) === status;

// Keep complete-list indices: drag/reorder operations must not use filtered indices.
export const getVisibleAttendanceEntries = (registrants, status = 'all') => registrants
    .map((registrant, index) => ({ registrant, index }))
    .filter(({ registrant }) => matchesAttendanceStatus(registrant, status));
